import { useState } from 'react'
import { ThreadWithMetadata } from 'ClientPortal/src/api/Queries/threads'
import { MessageList } from 'ClientPortal/src/pages/Orders/OrderDetails/ThreadList/MessageList/MessageList'
import { useMessageListData } from 'ClientPortal/src/pages/Orders/OrderDetails/ThreadList/MessageList/MessageList.data'
import MessageListTaskDrawerHeader from 'ClientPortal/src/pages/Orders/OrderDetails/ThreadList/MessageList/MessageListTaskDrawerHeader'
import { BORDER_WIDTH, PINNED_BANNER_HEIGHT, THREAD_HEADER_HEIGHT } from 'ClientPortal/src/pages/Orders/OrderDetails/ThreadList/constants'
import { TOOLBAR_HEIGHT } from 'ComponentLibrary'

type TaskSideDrawerMessageListProps = {
    thread: ThreadWithMetadata
}

export function TaskSideDrawerMessageList({ thread }: TaskSideDrawerMessageListProps) {
    const [isEditingParticipants, setIsEditingParticipants] = useState<boolean>(false)

    const {
        order,
        isOrderInitialLoading,
        replaceParticipantIds,
        currentUser,
        isPatchingThread,
        pinThread,
        unpinThread,
        createMessage,
        updateMessage,
        deleteMessage,
        uploadMessageDocuments,
        failedDocumentUploads,
        users,
        replaceTopic,
        downloadDocument,
        isDeleteThreadPending,
        orderObservers,
        externalParticipantUsers,
        isExternalParticipantsPending,
        orderLabel,
    } = useMessageListData({
        threadId: thread.uuid,
        orderId: thread.order_uuid,
    })

    const isPinned = !!currentUser?.pinned_threads.includes(thread.uuid)

    const header = (
        <MessageListTaskDrawerHeader
            orderObserverIds={order ? (order.observers ?? []) : undefined}
            orderObservers={orderObservers}
            thread={thread}
            isPinned={isPinned}
            pinThread={pinThread}
            unpinThread={unpinThread}
            setIsEditingParticipants={setIsEditingParticipants}
            currentUser={currentUser}
            replaceParticipantIds={replaceParticipantIds}
            isPatchingThread={isPatchingThread}
            isDeleteThreadPending={isDeleteThreadPending}
            externalParticipantUsers={externalParticipantUsers}
        />
    )

    return (
        <MessageList
            order={order}
            isOrderInitialLoading={isOrderInitialLoading}
            orderObservers={orderObservers}
            externalParticipantUsers={externalParticipantUsers}
            thread={thread}
            headerComponent={header}
            messagesContainerHeightBuffer={`${THREAD_HEADER_HEIGHT} + ${TOOLBAR_HEIGHT} + ${BORDER_WIDTH} + ${isPinned ? PINNED_BANNER_HEIGHT : '0px'}`}
            isEditingParticipants={isEditingParticipants}
            onEditParticipants={setIsEditingParticipants}
            createMessage={createMessage}
            updateMessage={updateMessage}
            deleteMessage={deleteMessage}
            isPatchingThread={isPatchingThread}
            uploadMessageDocuments={uploadMessageDocuments}
            failedDocumentUploads={failedDocumentUploads}
            users={users}
            replaceParticipantIds={replaceParticipantIds}
            currentUser={currentUser}
            replaceTopic={replaceTopic}
            downloadDocument={downloadDocument}
            externalParticipants={externalParticipantUsers}
            orderLabel={orderLabel}
            isExternalParticipantsPending={isExternalParticipantsPending}
        />
    )
}
